// Conversión pura entre divisas pivotando por USD (base del provider).
// Espejo de backend/src/services/fxService.js → convert().
export function convert(amount, from, to, rates) {
  const a = Number(amount);
  if (!Number.isFinite(a)) return 0;
  if (!from || !to || from === to) return a;
  if (!rates || typeof rates !== 'object') return a;
  const rFrom = from === 'USD' ? 1 : Number(rates[from]);
  const rTo   = to   === 'USD' ? 1 : Number(rates[to]);
  if (!rFrom || !rTo) return a;
  const usd = a / rFrom;
  return usd * rTo;
}

// Divisas sin decimales en su uso cotidiano local.
const ZERO_DECIMAL = new Set(['COP', 'CLP', 'ARS']);

export function formatMoney(amount, currency, locale) {
  const code = currency || 'USD';
  const max = ZERO_DECIMAL.has(code) ? 0 : 2;
  try {
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency: code,
      maximumFractionDigits: max,
      minimumFractionDigits: 0,
    }).format(Number(amount) || 0);
  } catch {
    return `${code} ${Math.round(Number(amount) || 0).toLocaleString()}`;
  }
}

// Lista canónica de divisas soportadas por el marketplace.
export const SUPPORTED_CURRENCIES = ['USD','EUR','MXN','COP','BRL','GBP','ARS','CLP','PEN'];

// Divisa por defecto según el idioma, cuando no hay país ni elección manual.
// (México-first para español, Brasil para portugués, USD para inglés.)
export const LANG_CURRENCY = {
  es: 'MXN', 'es-MX': 'MXN',
  pt: 'BRL', 'pt-BR': 'BRL',
  en: 'USD',
};

// Mapa país (ISO-3166 alpha-2, geo-IP) → divisa local soportada. Solo incluye
// países cuya divisa está en SUPPORTED_CURRENCIES; el resto cae al idioma.
const EUROZONE = ['AT','BE','HR','CY','EE','FI','FR','DE','GR','IE','IT','LV','LT','LU','MT','NL','PT','SK','SI','ES'];
export const COUNTRY_CURRENCY = {
  MX: 'MXN', CO: 'COP', BR: 'BRL', AR: 'ARS', CL: 'CLP', PE: 'PEN',
  GB: 'GBP',
  // Países que usan USD oficialmente además de EE. UU.
  US: 'USD', EC: 'USD', SV: 'USD', PA: 'USD',
  ...Object.fromEntries(EUROZONE.map((c) => [c, 'EUR'])),
};

// Divisa de visualización por defecto a partir del país (geo-IP) y, si el país
// no está mapeado, del idioma. Siempre devuelve una divisa soportada.
export function resolveCurrency({ country, lang } = {}) {
  const c = String(country || '').toUpperCase();
  const byCountry = COUNTRY_CURRENCY[c];
  if (byCountry && SUPPORTED_CURRENCIES.includes(byCountry)) return byCountry;
  const l = lang || '';
  return LANG_CURRENCY[l] || LANG_CURRENCY[l.slice(0, 2)] || 'USD';
}

export const CURRENCY_SYMBOLS = {
  USD: '$', EUR: '€', MXN: '$', COP: '$', BRL: 'R$',
  GBP: '£', ARS: '$', CLP: '$', PEN: 'S/',
};
